import styled from 'styled-components';
import { DisableSelection } from '../../../../../../styles/stylesStyled';

export const DefaultPlacement = styled.div<{ open: boolean }>`
  position: absolute;
  display: ${(props) => (props.open ? 'block' : 'none')};
  bottom: 98px;
  left: calc(50% - 359 / 2);
  padding: 0 8px;
  font-weight: normal;
  font-size: 18px;
  line-height: 26px;
  letter-spacing: 0.01em;
  color: ${(props) => props.theme.colors.neutral900};
  background: ${(props) => props.theme.colors.neutral50};
  border-radius: 15px;
  width: 359px;
  box-shadow: ${({ theme }) => theme.shadows.shadowXS};

  > div {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 20px 12px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
    :nth-child(3) {
      border: none;
    }
  }
  @media (max-width: 800px) {
    width: calc(100% - 30px);
  }
`;

export const DFButton = styled.div`
  position: relative;
  text-align: center;
  margin: 4px;
  border-radius: 8px;
  font-weight: 500;
  font-size: 14px;
  line-height: 18px;
  height: 50px;
  width: 197px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  background: ${(props) => props.theme.colors.neutral50};
  color: ${(props) => props.theme.colors.neutral900};
  box-shadow: ${(props) =>
    `inset 0px 0px 0px 2px ${props.theme.colors.secondary100};`};
  cursor: 'pointer';

  @media (max-width: 800px) {
    width: 100%;
    box-shadow: none;
    flex-direction: row;
    height: 30px;
    color: ${(props) => props.theme.colors.neutral500};
    span {
      margin-left: 5px;
    }
  }
  span {
    color: ${(props) => props.theme.colors.secondary100};
  }
  > * {
    ${DisableSelection}
  }
`;

export const Checkbox = styled.div<{ checked: boolean }>`
  width: 24px;
  height: 24px;
  border: 2px solid #fff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f48150;
  background: ${(props) => (props.checked ? '#F48150' : 'none')};
`;
